export default "__VITE_ASSET__bb563ed1__"